import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TimesheetService } from './../../../../core/services/services/timesheet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, finalize, forkJoin, of, takeUntil } from 'rxjs';

@Component({
  selector: 'app-list-cra-client-final',
  templateUrl: './list-cra-client-final.component.html',
  styleUrls: ['./list-cra-client-final.component.css'],
})
export class ListCraClientFinalComponent {
  annee = [
    { id: 2020, name: '2020' },
    { id: 2021, name: '2021' },
    { id: 2022, name: '2022' },
    { id: 2023, name: '2023' },
  ];

  currentYear!: number;
  currentUser: any;
  id: any;
  listOfMonths: any;
  // searchForm: FormGroup = this.createSearchForm();
  private unsubscribeAll: Subject<void> = new Subject();
  searchForm: FormGroup = this.createSearchForm();
  constructor(
    private serviceCra: TimesheetService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    // private translate: TranslateService,
    private router: Router
  ) {}
  ngOnInit(): void {
    forkJoin([this.getCurrentYear(), this.getIdUser()]).subscribe(() => {
      this.getListOfMonths();
    });

    const userLanguage = 'fr';

    //  this.translate.setDefaultLang('en');
    //  this.translate.use(userLanguage);

    //  this.translate.getTranslation(userLanguage).subscribe((translations) => {
    //    this.translate.setTranslation(userLanguage, translations, true);
    //  });
  }

  getCurrentYear() {
    const now = new Date();
    this.currentYear = now.getFullYear();
    return of(undefined);
  }

  getIdUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.id = JSON.parse(this.currentUser).id;
    return of(undefined);
  }

  getListOfMonths() {
    let dataPayload = { year: this.currentYear, client_id: this.id };

    console.log('yearrrrrrrrrrr', this.currentYear);
    console.log('idddddddddddddddddddddddddd', this.id);

    this.spinner.show();

    this.serviceCra
      .getAllListOfMonthsOfYear(dataPayload)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe(
        (res: any) => {
          this.listOfMonths = res?.data;
          console.log('data listOfMonths ', this.listOfMonths);
        },
        (error) => {
          console.error('Error fetching listOfMonths:', error);
        }
      );
  }
  //////////////////////////////////////////////////////////////////////////////////////////

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      year: [data ? data.year : null],
    });
  }
  ///////////////////////////////////////////////////////////////////////////////////////////

  searchYearCra() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.id = JSON.parse(this.currentUser).id;
    let data = {
      year: this.searchForm.value.year,

      client_id: this.id,
    };
    this.spinner.show();
    this.serviceCra
      .searshtimesheet(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('response format:', res);
          this.listOfMonths = res.data;
          this.spinner.hide();
        },
        error: () => {
          console.error('Error during cra search');
          this.spinner.hide();
        },
      });
  }

  voirListCraEntreprisesByMonth(idmonth: any, year: any) {
    this.router.navigate([
      '/cra/liste-cra-mois',
      { month: idmonth, year: year },
    ]);
  }
}
